(function () {
  var TARGET_PATH = '/pages/precursores-y-qumicos-esenciales';
  if (window.location.pathname !== TARGET_PATH) return;

  function addReturnButton() {
    if (document.getElementById('CocisaVolverTienda')) return true;

    var nodes = document.querySelectorAll('body *');
    var successNode = null;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children.length > 0) continue;
      var txt = (el.textContent || '').trim().toLowerCase();
      if (txt === 'thank you. the form has been submitted.' ||
          txt === 'gracias. el formulario ha sido enviado.' ||
          txt === 'thank you! the form has been submitted.') {
        successNode = el;
        break;
      }
    }
    if (!successNode) return false;

    var wrap = document.createElement('div');
    wrap.id = 'CocisaVolverTienda';
    wrap.style.cssText = 'margin:24px auto 12px;text-align:center;max-width:420px;padding:0 16px;';

    var msg = document.createElement('p');
    msg.textContent = 'Documentación enviada correctamente. La revisaremos para autorizar tu compra.';
    msg.style.cssText = 'margin:0 0 14px;font-weight:600;';

    var link = document.createElement('a');
    link.href = '/collections/all';
    link.textContent = 'Volver a la tienda';
    link.className = 'btn';
    link.style.cssText = 'display:block;width:100%;text-align:center;';

    wrap.appendChild(msg);
    wrap.appendChild(link);

    var anchor = successNode.parentElement || successNode;
    anchor.insertAdjacentElement('afterend', wrap);
    return true;
  }

  if (addReturnButton()) return;

  var observer = new MutationObserver(function () {
    if (addReturnButton()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  window.setTimeout(function () { observer.disconnect(); }, 30000);
})();
